"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyValue = void 0;
const react_1 = require("react");
const useLazyValue = (propsValue, onPropsChange, sameValue) => {
    const lastChangedValueRef = (0, react_1.useRef)(propsValue);
    const lastLazyValueRef = (0, react_1.useRef)(propsValue);
    (0, react_1.useEffect)(() => {
        if (sameValue(lastLazyValueRef.current, propsValue))
            return;
        if (sameValue(lastChangedValueRef.current, propsValue))
            return;
        lastLazyValueRef.current = propsValue;
        lastChangedValueRef.current = propsValue;
    }, [propsValue, sameValue]);
    return [
        lastLazyValueRef.current,
        (value) => {
            // Keep == operator. undefined == '' == null;
            if (sameValue(lastChangedValueRef.current, value))
                return;
            lastChangedValueRef.current = value;
            onPropsChange === null || onPropsChange === void 0 ? void 0 : onPropsChange(lastChangedValueRef.current);
        },
    ];
};
exports.useLazyValue = useLazyValue;
//# sourceMappingURL=useLazyValue.js.map